import { bool, string } from "prop-types"
import { Icon } from "source/shared/components"

const NamedAttendeeForm = ({
  title,
  complete,
  disabled = null,
  disabledMessage = null,
  href = null,
}) => {
  return (
    <div className="d-f jc-sb mt-1">
      <div
        style={{
          display: "flex",
          flex: "1",
          flexWrap: "nowrap",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </div>
        <div className="ml-1" style={{ flexShrink: "0" }}>
          {complete ? (
            <span className="mr-1 ml-1 c-emerald">
              <Icon
                symbol="general#check"
                className="fs-8"
                style={{ verticalAlign: "middle" }}
                aria-hidden
              />
            </span>
          ) : (
            <span className="mr-1 c-marigold">
              <span
                className="pl-6p pr-1p ml-1"
                style={{ fontSize: "12px", verticalAlign: "middle" }}
              >
                <Icon
                  symbol="general#exclamation-triangle"
                  className={`fs-8 symbol`}
                  aria-hidden
                />
              </span>
            </span>
          )}
        </div>
      </div>
      <div style={{ flexShrink: "0" }}>
        {disabled ? (
          <span
            className="btn sm-btn outline-btn primary-btn"
            title={disabledMessage ? disabledMessage : null}
            disabled
          >
            View
          </span>
        ) : (
          <a
            target="_blank"
            rel="noreferrer"
            href={href}
            className="btn sm-btn outline-btn primary-btn"
          >
            View
          </a>
        )}
      </div>
    </div>
  )
}

NamedAttendeeForm.propTypes = {
  title: string.isRequired,
  complete: bool.isRequired,
  disabled: bool,
  disabledMessage: string,
  href: string,
}

export default NamedAttendeeForm
